<div class="plugin-wrapper">
    <ng-container *ngIf="permission else notApolloAccessTpl">
        <nav class="tab_navigation" >
            <core-helpers-navigation-vertical-tabs [menu]="menuApollo"></core-helpers-navigation-vertical-tabs>
        </nav>
        <section class="plugin-main">
            <router-outlet></router-outlet>
        </section>
    </ng-container>
    <ng-template #notApolloAccessTpl>
        <div>
            <nav class="tab_navigation"></nav>
            <section class="plugin-main">
                <core-layout-error-not-found></core-layout-error-not-found>
            </section>
        </div>
    </ng-template>
</div>
